module.exports = __webpack_public_path__ + "static/media/half.b183cff4.png";